import { useCallback } from "react"
import { useRouter } from "next/router"

import { TRACKING_EVENTS, useAnalytics } from "@/lib/analytics"

import type { SubscriptionResponse } from "../types"

const CONVERT_DESTINATION = "/reactivate"

/**
 * Navigation + tracking for the convert-to-self-serve CTA, shared by every
 * surface that offers it (settings card, status banner) so the route string
 * and event payload live in one place.
 */
export function useConvertCta() {
  const router = useRouter()
  const { trackEvent } = useAnalytics()

  return useCallback(
    (source: string, subscriptionStatus?: SubscriptionResponse["status"]) => {
      try {
        trackEvent(TRACKING_EVENTS.BILLING.CONVERT_CTA_CLICKED, {
          source,
          subscription_status: subscriptionStatus,
        })
      } catch {
        // analytics is best-effort
      }
      void router.push(CONVERT_DESTINATION)
    },
    [router, trackEvent],
  )
}
